/* YV Indy ads
   1. Rotation: when a slot holds several ads, show one at random.
   2. In-article: copy the hidden ad template in between story paragraphs. */
(function () {
    function rotate(slot) {
        var ads = slot.querySelectorAll('[data-ad]');
        if (ads.length < 2) return;
        var pick = Math.floor(Math.random() * ads.length);
        slot.classList.add('is-rotated');
        ads.forEach(function (ad, i) { ad.classList.toggle('is-active', i === pick); });
    }

    document.querySelectorAll('[data-ad-slot]').forEach(rotate);

    var tpl = document.getElementById('yv-article-ad');
    var content = document.querySelector('.post-template .gh-content');
    if (!tpl || !content || !tpl.content.querySelector('[data-ad]')) return;

    var paragraphs = Array.prototype.filter.call(content.children, function (el) {
        return el.tagName === 'P' && el.textContent.trim().length > 0;
    });
    if (paragraphs.length < 3) return;

    // First ad after the 3rd paragraph (after the last one in short stories);
    // a second ad after the 11th paragraph in long stories, using a different ad.
    var spots = [];
    if (paragraphs.length >= 6) spots.push(2); else spots.push(paragraphs.length - 1);
    if (paragraphs.length >= 16) spots.push(10);

    var used = [];
    spots.forEach(function (index) {
        var slot = tpl.content.firstElementChild.cloneNode(true);
        var ads = slot.querySelectorAll('[data-ad]');
        if (ads.length > 1) {
            var choices = [];
            ads.forEach(function (ad, i) { if (used.indexOf(i) === -1) choices.push(i); });
            var pick = choices[Math.floor(Math.random() * choices.length)];
            used.push(pick);
            slot.classList.add('is-rotated');
            ads.forEach(function (ad, i) { ad.classList.toggle('is-active', i === pick); });
        }
        paragraphs[index].insertAdjacentElement('afterend', slot);
    });
})();
